import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-ml-xs"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_checkbox, {
      "model-value": _ctx.control.data,
      label: _ctx.control.uischema.label || _ctx.control.label || undefined,
      "onUpdate:modelValue": _ctx.onChange,
      class: "primary",
      disable: _ctx.disable || _ctx.control.uischema.readOnly
    }, null, 8, ["model-value", "label", "onUpdate:modelValue", "disable"]),
    (_ctx.control.uischema?.options?.linkToDocs)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.control.uischema?.options?.linkToDocs
          }, "docs", 8, _hoisted_3),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (_ctx.control.uischema?.options?.tooltip)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _createVNode(_component_q_icon, {
            name: "help_outline",
            size: "16px",
            class: "cursor-pointer q-ml-xs q-mb-sm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, { style: {"width":"430px"} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.control.uischema?.options?.tooltip), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}